import React from 'react';
import { BRAND_LOGO, BRAND_MASCOT } from '../utils/brandAssets';

export default function OperationsHero() {
  return (
    <section className="ops-hero relative mb-8 overflow-hidden rounded-3xl border border-slate-800/10 bg-gradient-to-br from-[#0f0f10] via-[#17171a] to-[#1f1f24] px-6 py-8 text-white shadow-lift md:px-10 md:py-10">
      <div
        className="pointer-events-none absolute -right-8 -top-6 h-56 w-56 opacity-[0.07] grayscale md:h-72 md:w-72"
        aria-hidden="true"
      >
        <img
          src={BRAND_MASCOT}
          alt=""
          loading="lazy"
          decoding="async"
          className="h-full w-full object-contain object-right-top"
        />
      </div>

      <div
        className="pointer-events-none absolute bottom-0 right-24 hidden h-40 w-40 opacity-[0.04] grayscale md:block"
        aria-hidden="true"
      >
        <img src={BRAND_MASCOT} alt="" className="h-full w-full object-contain" />
      </div>

      <div className="relative z-10 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl animate-fade-up">
          <img
            src={BRAND_LOGO}
            alt="El Cachuchón"
            loading="eager"
            decoding="async"
            className="h-10 w-auto max-w-[280px] object-contain object-left md:h-11"
          />

          <p className="mt-4 text-xs font-semibold uppercase tracking-[0.28em] text-amber-400/90">
            Premium Fitted Operations
          </p>

          <h2 className="mt-2 text-3xl font-bold tracking-tight md:text-4xl">
            Operations Dashboard
          </h2>

          <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-300 md:text-base">
            Manage caps inventory, multi-angle product galleries, orders, and customer activity
            from one modern streetwear command center.
          </p>
        </div>

        <div className="hidden shrink-0 rounded-2xl border border-white/10 bg-white/5 px-5 py-4 backdrop-blur-sm md:block animate-fade-up animation-delay-100">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400">
            Status
          </p>
          <p className="mt-1 text-sm font-medium text-emerald-300">Production Live</p>
        </div>
      </div>
    </section>
  );
}
